import { openBrowserAsync } from "expo-web-browser"

export const openPrivacyPolicy = () => {
  return openBrowserAsync("https://www.ra9plus.jp/privacypolicy")
}
